/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Status({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.837 14.346a.6.6 0 0 1 .155 1.19 7.7 7.7 0 0 1-1.984 0 .6.6 0 0 1 .155-1.19 6.5 6.5 0 0 0 1.674 0m-6.756-2.56a.6.6 0 0 1 .84.11c.342.443.74.841 1.183 1.182a.6.6 0 0 1-.731.951 7.6 7.6 0 0 1-1.402-1.402.6.6 0 0 1 .11-.84m10.997.11a.6.6 0 0 1 .951.731 7.6 7.6 0 0 1-1.402 1.402.6.6 0 0 1-.732-.95 6.4 6.4 0 0 0 1.183-1.184M.4 8q0-.504.064-.992a.6.6 0 0 1 1.19.155 6.5 6.5 0 0 0 0 1.674.6.6 0 0 1-1.19.155A8 8 0 0 1 .4 8m14 0q0-.426-.054-.837a.6.6 0 0 1 1.19-.155 7.7 7.7 0 0 1 0 1.984.6.6 0 0 1-1.19-.155q.053-.411.054-.837M3.373 1.97a.6.6 0 0 1 .731.952c-.443.34-.841.739-1.182 1.182a.6.6 0 0 1-.951-.731 7.6 7.6 0 0 1 1.402-1.402m8.413.111a.6.6 0 0 1 .841-.11c.526.404.998.876 1.402 1.402a.6.6 0 0 1-.95.731 6.4 6.4 0 0 0-1.184-1.182.6.6 0 0 1-.109-.841M8 .401q.504 0 .992.063a.6.6 0 0 1-.155 1.19 6.5 6.5 0 0 0-1.674 0 .6.6 0 0 1-.155-1.19Q7.496.4 8 .4" /></svg>;
}
;